import React from 'react'
import { Link } from 'react-router-dom'
import { pathOr, slice } from 'ramda'
import { fisherYatesShuffle } from '../../utils/randomness'

const TopProduct = ({ topProduct, logClickEvent }) => {
  const displayName =
    pathOr('', ['siteDisplayName'], topProduct) ||
    pathOr('Product Name Unavailable', ['displayName'], topProduct)
  /* We render only the first 20 characters of the display name and add elipses */
  const displayNameToRender =
    displayName.length > 20 ? `${slice(0, 20, displayName)}...` : displayName

  const urlComponent = pathOr(null, ['urlComponent'], topProduct)
  const id = pathOr(null, ['id'], topProduct)

  /* Where we should we navigate to if we do not have a path ? */
  const productPath = urlComponent
    ? `/product/${urlComponent}`
    : id
    ? `/product/${id}`
    : `/products`

  return (
    <div
      className="tcp__link-block"
      onClick={() =>
        logClickEvent({ eventType: `Category_Page_TopProduct_Click`, itemDetails: topProduct })
      }
    >
      <Link to={productPath} className="tcp__link">
        {displayNameToRender}
      </Link>
    </div>
  )
}

const TopProducts = ({ topProducts, logClickEvent }) => {
  /* We randomly select 6 top products for each page mount */
  const randomPermOfTopProducts = fisherYatesShuffle(topProducts)

  const topProductsToRender = slice(0, 6, randomPermOfTopProducts)

  return (
    <div className="top-cp tcp">
      <div className="tcp__block">
        <div className="container">
          {/* <div className="tcp__categories">
                    <p className="tcp__title">TOP CATEGORIES</p>

                    <div className="tcp__links">
                        <div className="tcp__link-block">
                            <a href="#" className="tcp__link">Category</a>
                        </div>

                        <div className="tcp__link-block">
                            <a href="#" className="tcp__link">Category</a>
                        </div>

                        <div className="tcp__link-block">
                            <a href="#" className="tcp__link">Category</a>
                        </div>
                    </div>
                </div> */}

          <div className="tcp__products">
            <p className="tcp__title">TOP PRODUCTS</p>

            <div className="tcp__links">
              {topProductsToRender.map((topProduct, index) => (
                <TopProduct topProduct={topProduct} key={index} logClickEvent={logClickEvent} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

{
  /* <div className="tcp__link-block">
<a href="#" className="tcp__link">Product</a>
</div>

<div className="tcp__link-block">
<a href="#" className="tcp__link">Product</a>
</div>

<div className="tcp__link-block">
<a href="#" className="tcp__link">Product</a>
</div> */
}
export default TopProducts
